import { HydratedRouter } from 'react-router/dom';
import type {
  unstable_InstrumentationHandlerResult,
  unstable_InstrumentRouteFunction,
  unstable_InstrumentRouterFunction,
} from 'react-router';
import { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { datadogRum } from '@datadog/browser-rum';

const routerInstrumentations: unstable_InstrumentRouterFunction = (router) => {
  router.instrument({
    async fetch(fn, { href, formMethod, fetcherKey }) {
      const routeAttributes = {
        'fetcher.href': href,
        'fetcher.formMethod': formMethod?.toString() ?? '',
        'fetcher.key': fetcherKey,
      };
      rumAction(`fetcher:${fetcherKey}:${href}`, routeAttributes, fn);
    },
  });
};

const routeInstrumentation: unstable_InstrumentRouteFunction = (route) => {
  const routeAttributes = {
    'route.id': route.id,
    'route.path': route.path ?? '',
  };

  route.instrument({
    async loader(fn) {
      rumAction(`loader:${route.id}`, { ...routeAttributes }, fn);
    },
    async action(fn) {
      rumAction(`action:${route.id}`, { ...routeAttributes }, fn);
    },
  });
};

async function rumAction(
  label: string,
  attributes: Record<string, string>,
  cb: () => Promise<unstable_InstrumentationHandlerResult>,
) {
  const { error } = await cb();
  if (error) {
    datadogRum.addError(error, { label, attributes });
  }
  datadogRum.addAction(label, attributes);
}

const unstable_instrumentations = [
  {
    route: routeInstrumentation,
    router: routerInstrumentations,
  },
];

startTransition(() => {
  hydrateRoot(
    document,
    <HydratedRouter unstable_instrumentations={unstable_instrumentations} />,
  );
});
